class DiscountSaveController {

    constructor($rootScope, $state, $stateParams, eventsService, access) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.eventsService = eventsService;
        this.access = access;
    }

    $onInit() {
        this.activeTab = this.$stateParams.tab || 'discount';
        if ( !this.days || !this.treatments ) {
          this.days = [];
          this.treatments = [];

          this.eventpromise = this.eventsService.collectGrouped().then(response => {
            this.days = this.days.concat(response.SpaDay);
            this.treatments = this.treatments.concat(response.Treatment);
            return response;
          });
        }
    }
}

DiscountSaveController.$inject = [ '$rootScope', '$state', '$stateParams', 'eventsService', 'access' ];

export default DiscountSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/controllers/discount.save.controller.js